import React from 'react'
import { Icon, type IDropdownItem } from 'shared/ui'
import { type ISendFromStoreItem, SendFromTriggerInnerContent } from 'widgets/SendFrom'
import styles from './styles.module.scss'

type ISelectedItemProps = {
  item: IDropdownItem<ISendFromStoreItem>
  onDelete?: (item: IDropdownItem<ISendFromStoreItem>) => void
  showNumbersCount?: boolean
  hideNumbers?: boolean
  triggerInnerContentClassName?: string
}

export const SelectedItem = ({
  item,
  onDelete,
  showNumbersCount,
  hideNumbers,
  triggerInnerContentClassName,
}: ISelectedItemProps) => {
  return (
    <div className={styles.wrap}>
      <SendFromTriggerInnerContent
        item={item}
        showNumbersCount={showNumbersCount}
        hideNumbers={hideNumbers}
        triggerInnerContentClassName={triggerInnerContentClassName}
      />
      {onDelete && (
        <div className={styles.closeIcon} onClick={() => onDelete?.(item)}>
          <Icon icon='close' tertiary />
        </div>
      )}
    </div>
  )
}
